import React from 'react'
import { SVGIcon } from '~/utils/types'


export const Play = (props: SVGIcon) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59 72">
    <defs>
      <linearGradient
        id="prefix__a"
        x1="55.696%"
        x2="16.426%"
        y1="17.82%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#008DD1" />
        <stop offset="100%" stopColor="#5CB235" />
      </linearGradient>
    </defs>
    <path
      fill="none"
      fillRule="evenodd"
      stroke="url(#prefix__a)"
      strokeWidth="2"
      d="M0 4.276v63.448c0 1.326 1.075 2.4 2.4 2.4.441 0 .874-.121 1.25-.351l51.992-31.724c1.132-.69 1.49-2.168.799-3.3-.199-.325-.473-.599-.799-.798L3.65 2.227c-1.131-.69-2.608-.333-3.299.799-.23.376-.351.809-.351 1.25z"
    />
  </svg>
)
